const naked_images = document.querySelectorAll('article > img');
if( typeof(naked_images) != 'undefined' && naked_images != null ) {
  naked_images.forEach( element => {
    const parent = element.closest('article');
    const figure = document.createElement('figure');
    if( element.classList.contains('size-medium') ) {
      figure.classList.add('aligncenter');
    }
    figure.appendChild(element.cloneNode(true));
    parent.insertBefore(figure,element);
    element.remove();
  });
}
